import React from 'react';
import { Link } from "react-router-dom";
import SEO from "../common/SEO";
import HeaderTwo from '../common/header/HeaderTwo';
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';


const Register = () => {
    return (
        <>
            <SEO title="N01ZET Signin Signup login Enregistrement" />
            <main className="page-wrapper">
                <HeaderTwo btnStyle="btn-small btn-icon" HeaderSTyle="header-transparent" />

                {/* Start Slider Area  */}
                <div className='register-bg1' style={{backgroundImage:"url('/images/bg/bg-login.png')"}}>
                    <div className="slider-area slider-style-1 variation-default height-850 bg_image" style={{backgroundImage:"url('/images/bg/bg-login-2.png')",backgroundSize:"400px",backgroundRepeat:"no-repeat",backgroundPosition:"0%"}} data-black-overlay="1" >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4">

                                </div>
                                <div className='col-lg-4 login-section'>
                                    <h1 className="login-title mt-5">Create your N01zet account</h1>
                                    <form className="contact-form-2" action="" >
                                        <div className="form-group">
                                            <label>Email</label>
                                            <input type="email" name="email" placeholder="Your Email Address" required />
                                        </div>

                                        <div className="form-group">
                                            <label>First Name</label>
                                            <input type="text" name="fname" placeholder="Your First Name" required />
                                        </div>

                                        <div className="form-group">
                                            <label>Last Name</label>
                                            <input type="text" name="lname" placeholder="Your Last Name" required />
                                        </div>

                                        <div className="form-group">
                                            <label>Password</label>
                                            <input type="password" name="password" placeholder="Your Password" required/>
                                        </div>

                                        <div className="form-group">
                                            <button className="btn-default btn-small" style={{width:"100%"}}>Confirmer</button>
                                        </div> 

                                        {/* <div className="form-group">
                                            {result ? <Result /> : null}
                                        </div>  */}
                                    </form>
                                    <div className='text-center login-text'>
                                        <p>Already have an account? <Link to="/login" className='login-text' style={{fontWeight:'bold'}}>Login</Link></p>
                                    </div>
                                </div>
                                <div className='col-lg-4'>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Slider Area  */}
              
                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default Register
